import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { UsersApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseUsersByRoleGetProps {
  /** Role name to filter by (e.g. "Member", "Admin") */
  role: string;
  /** When false, the request is not sent */
  enabled?: boolean;
}

export const useUsersByRoleGet = ({
  role,
  enabled = true,
}: UseUsersByRoleGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.UsersByRoleGet, role],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(UsersApi, accessToken);
      return service.usersByRoleGet({ role });
    },
    enabled: !!accessToken && !!role && enabled,
  });

  return {
    data: data ?? [],
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};
